<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      class="mt-4"
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
      >
        <v-card class="elevation-12">
          <v-toolbar
              color="primary"
              dark
              flat
          >
            <v-toolbar-title>Identification</v-toolbar-title>
          </v-toolbar>
          <v-card-text>

            <v-alert type="error" :value="error" v-text="error" class="mb-4"></v-alert>

            <v-form
              ref="loginForm"
              v-model="loginValid"
            >
              <v-text-field
                label="Adresse courriel"
                v-model="credentials.email"
                prepend-icon="person"
                type="text"
                :rules="emailRules"
                validate-on-blur
              ></v-text-field>
              <v-text-field
                label="Mot de passe"
                v-model="credentials.password"
                prepend-icon="lock"
                type="password"
                :rules="passwordRules"
                validate-on-blur
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login">Se connecter</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { Auth } from '../auth'

export default {
  data () {
    return {
      loginValid: true,

      credentials: {
        email: "",
        password: ""
      },

      error: '',

      emailRules: [
        v => !!v || 'L\'adresse courriel est obligatoire',
        v => (!v || /.+@.+/.test(v)) || 'L\'adresse courriel n\'est pas valide'
      ],

      passwordRules: [
        v => !!v || 'Le mot de passe est obligatoire'
      ]
    }
  },

  methods: {
    validateLogin() {
      return this.$refs.loginForm.validate();
    },

    login() {
      this.error = '';

      if (! this.validateLogin()) {
        return;
      }

      const credentials = {
        email: this.credentials.email,
        password: this.credentials.password
      };

      Auth.login(this, credentials, '/');
    }
  },

  mounted() {
    if (Auth.isAuthenticated()) {
      this.$router.replace('/');
    }
  },
}

</script>

<style>

</style>
